import Context from '@alltrails/types/Context';

const getHasLegacyPortalAccess = (context: Context) => {
  const legacyGroups = (context as Context & { groups?: any[] }).groups;

  return Boolean(legacyGroups?.length);
};

export default getHasLegacyPortalAccess;
